import { Platform } from '@/core/Platform';
import { StyleSheet } from '@/core/StyleSheet';

export default StyleSheet.create({
	slots: {
		flex: 1,
		flexDirection: 'row',
		height: 42,
		paddingBottom: 10,
		...Platform.select({
			web: {
				position: 'relative',
			},
		}),
	},

	column: {
		paddingTop: 5,
		height: 32,
	},

	wholeHour: {
		borderColor: 'rgb(80, 80, 80)',
		borderRightWidth: 1,
		marginRight: -1,
		...Platform.select({
			web: {
				borderRightStyle: 'solid',
			},
		}),
	},

	slot: {
		backgroundColor: 'rgba(88, 151, 146, 0.1)',
		borderColor: 'rgb(80, 80, 80)',
		borderWidth: 1,
		height: 27,
		marginRight: -1,
		width: 14,
		...Platform.select({
			web: {
				borderStyle: 'solid',
			},
		}),
	},
});
